import React, { useCallback, useState } from "react";

import { ALARMS_TABLE_STRINGS, valueStrings } from "constants/constantStrings";

import AgTable from "components/AgTable";
import BadgeLabel from "components/BadgeLabel";
import DupontButton from "components/DupontButton";
import Filter from "components/Filter";

import { getAlarmsTableColDef } from "./ChartAlarms.table.config";

import "./ChartAlarms.scss";

export const CHART_ALARMS_ACTION = {
  CANCEL: "Cancel",
  SAVE: "Save",
  UPDATE: "Update"
};

// eslint-disable-next-line react/display-name
const ChartAlarms = React.memo(props => {
  const { OrignialAlarms } = props;
  const [filterValue, setFilterValue] = useState("");
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(false);
  const [isManualRowSelection, setIsManualRowSelection] = useState(false);
  const [editedAlarm, setEditedAlarm] = useState();
  const [alarmToUpdate, setAlarmToUpdate] = useState();
  const [agGridApi, setAgGridApi] = useState();
  const [updatedAlarms, setUpdatedAlarms] = useState([]);
  const [chartAlarmsBadgeCount, setChartAlarmsBadgeCount] = useState(OrignialAlarms?.length || "");

  const isNotSameAlarmSelection = newAlarm => alarmToUpdate?.AlarmId !== newAlarm.AlarmId;

  const getAlarmsData = params => {
    const allAlarms = [];
    params.api.forEachNode(node => allAlarms.push(node.data));
    const activeAlarms = params.api.getSelectedRows();
    return { allAlarms, activeAlarms };
  };

  const checkforChangedAlarms = currentList => {
    let updatedList = [...updatedAlarms];
    currentList.forEach(item => {
      const orignalAlarm = OrignialAlarms.find(({ AlarmId }) => AlarmId === item.AlarmId);
      const idx = updatedList.findIndex(alarm => alarm.AlarmId === item.AlarmId);
      if (orignalAlarm.Enable !== item.Enable) {
        if (idx > -1) {
          updatedList[idx] = item;
        } else {
          updatedList = [...updatedList, item];
        }
      } else if (idx > -1) {
        updatedList.splice(idx, 1);
      }
    });
    setUpdatedAlarms(updatedList);
  };

  function onSelectionChanged(params) {
    if (isManualRowSelection && isNotSameAlarmSelection(editedAlarm)) {
      const totalAlarms = OrignialAlarms.length;
      const totalActiveAlarms = params.api.getSelectedRows().length;
      const isAllAlarmsUpdated = !totalActiveAlarms || totalActiveAlarms === totalAlarms;
      if (!isAllAlarmsUpdated) {
        setAlarmToUpdate(editedAlarm);
      }
      const { allAlarms } = getAlarmsData(params);
      checkforChangedAlarms(allAlarms);
      props.onAlarmActions({ action: CHART_ALARMS_ACTION.UPDATE, data: allAlarms });
    }
  }

  const onRowSelected = event => {
    const { data, node } = event;
    const Enable = node.isSelected();
    const updatedRowData = { ...data, Enable };
    setEditedAlarm(updatedRowData);
    node.setData(updatedRowData);
  };

  const onGridReady = useCallback(params => {
    const gridAPI = params.api;
    setAgGridApi(gridAPI);
    gridAPI.forEachNode(node => {
      node.setSelected(Boolean(node.data.Enable));
    });
    gridAPI.addGlobalListener(type => {
      if (type === "rowSelected") {
        setIsManualRowSelection(true);
      }
    });
  }, []);

  const getTableData = () => {
    const updatedTags = [];
    if (agGridApi) agGridApi.forEachNode(node => updatedTags.push(node.data));
    return updatedTags;
  };

  const onCancel = () => props.onAlarmActions({ action: CHART_ALARMS_ACTION.CANCEL });

  const onSave = () => {
    const Alarms = getTableData();
    const UpdatedAlarmsList = updatedAlarms.map(({ Enable, AlarmId }) => ({ Enable, AlarmId }));
    props.onAlarmActions({ action: CHART_ALARMS_ACTION.SAVE, data: { Alarms, UpdatedAlarmsList } });
  };

  return (
    <div className="chart-tag-container whiteBackground chartBottomContainer">
      <div className="chartBottomTopRow">
        <div className="calculatedValueText d-flex">
          <BadgeLabel badgeDescription={ALARMS_TABLE_STRINGS.alarmsDetails} badgeText={chartAlarmsBadgeCount} />
        </div>
        <div className="d-flex">
          <Filter
            data={OrignialAlarms}
            setFilterValue={setFilterValue}
            showfilter={false}
            setShowTableFilterIcon={setShowTableFilterIcon}
            showTableFilterIcon={showTableFilterIcon}
            customClass={"alarms-filter-padding"}
          />
          <DupontButton type="secondary" onClick={onCancel} customClass="chart-tag--btn-spacing">
            {valueStrings.cancel}
          </DupontButton>
          <DupontButton type="primary" onClick={onSave} disabled={updatedAlarms.length === 0}>
            {valueStrings.save}
          </DupontButton>
        </div>
      </div>
      <div className="fullWidth height--100">
        <AgTable
          rowData={OrignialAlarms}
          quickFilterText={filterValue}
          columnDefs={getAlarmsTableColDef(showTableFilterIcon)}
          onSelectionChanged={onSelectionChanged}
          onGridReady={onGridReady}
          onRowSelected={onRowSelected}
          rowHeight={34}
          customHeight="180px"
          setBadgeCount={setChartAlarmsBadgeCount}
        />
      </div>
    </div>
  );
});

export default ChartAlarms;
